import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { logError } from "@/lib/log";

const Flag = ({ ok, children }) => (
  <span className={`text-xs px-2 py-0.5 rounded-full border ${ok ? "bg-emerald-50 border-emerald-300 text-emerald-800" : "bg-red-50 border-red-300 text-red-700"}`}>{children}</span>
);

export const GatewayPanel = () => {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/payments/gateway/status").then((r) => setSt(r.data))
    .catch((e) => logError("Gateway status failed", e));
  useEffect(() => { load(); }, []);

  const test = async () => {
    setBusy(true);
    try {
      const r = await api.post("/payments/gateway/test", {});
      (r.data.ok ? toast.success : toast.error)(r.data.message);
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Test gagal");
    } finally { setBusy(false); }
  };

  if (!st) return null;
  return (
    <section className="bg-white border border-black/10 rounded-lg p-5" data-testid="gateway-panel">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <h2 className="text-base font-semibold">Pembayaran Online — Midtrans Snap</h2>
        <button data-testid="gateway-test-btn" disabled={busy} onClick={test}
          className="h-9 px-4 rounded-md border border-black/15 text-xs hover:border-lm-red disabled:opacity-50">
          {busy ? "Menguji…" : "Test Connection"}
        </button>
      </div>
      <div className="mt-3 flex flex-wrap items-center gap-2">
        <Flag ok={st.configured}>{st.configured ? "Terkonfigurasi" : "Belum dikonfigurasi"}</Flag>
        <Flag ok={st.env === "production" || st.env === "sandbox"}>Environment: {st.env}</Flag>
        <Flag ok={st.client_key_set}>Client Key</Flag>
        <Flag ok={st.server_key_set}>Server Key</Flag>
        <span className="text-xs text-ink-soft">Merchant ID: {st.merchant_id || "—"}</span>
      </div>
      {st.env === "production" && (
        <p className="mt-3 text-xs text-amber-700" data-testid="gateway-prod-note">
          Environment <b>Production</b>: transaksi menagih uang sungguhan dan hanya jalan setelah akun
          merchant Anda disetujui Midtrans. Untuk uji coba, pakai key Sandbox dari dashboard.sandbox.midtrans.com.
        </p>
      )}
      {st.env === "sandbox" && (
        <p className="mt-3 text-xs text-ink-soft" data-testid="gateway-sandbox-note">
          Environment <b>Sandbox</b>: pembayaran hanya simulasi, tidak ada uang sungguhan. Kirim key Production
          (Merchant ID + Client Key + Server Key) kalau sudah siap menerima pembayaran nyata.
        </p>
      )}
      <div className="mt-4 text-xs space-y-1.5 text-ink-soft">
        <div>Webhook URL (paste di Midtrans Dashboard → Settings → Configuration → Payment Notification URL):</div>
        <code data-testid="gateway-webhook-url" className="block bg-cream-dark rounded px-3 py-2 text-ink break-all">{st.webhook_url}</code>
        <div>Webhook terakhir: {st.last_webhook_at || "belum ada"} · Percobaan bayar: {st.attempts} · Berhasil: {st.paid_attempts}</div>
        {st.last_error && <div className="text-red-600">Error terakhir: {st.last_error}</div>}
      </div>
    </section>
  );
};
